import { formatHistoryValue } from '../modals/ResourceActionModals/ResourceHistoryModal/helpers';
import { ResourcePreviewChangesValue } from './changeContext';

const valueAtPath = (value: unknown, path: string[]): unknown =>
    path.reduce<unknown>(
        (current, key) =>
            current !== null && typeof current === 'object' && Object.hasOwn(current, key)
                ? (current as Record<string, unknown>)[key]
                : undefined,
        value,
    );

export const findPreviewFieldChange = (
    preview: ResourcePreviewChangesValue | null,
    field: string,
    resourceId: string | undefined,
    resourceType: string,
) => {
    if (!preview || preview.resourceId !== resourceId || preview.resourceType !== resourceType) {return undefined;}
    const index = preview.changes.findIndex(
        (change) => change.path === field || (change.path && field.startsWith(change.path + '.')),
    );
    if (index < 0) {return undefined;}
    const change = preview.changes[index];
    if (change.path === field) {return { change, index };}
    const source = preview.version.changes?.find((item) => item.path === change.path);
    const path = field.slice((change.path?.length ?? 0) + 1).split('.');
    const before = valueAtPath(source?.before, path);
    const after = valueAtPath(source?.after, path);
    if (JSON.stringify(before) === JSON.stringify(after)) {return undefined;}
    return {
        index,
        change: {
            ...change,
            before: formatHistoryValue(before),
            after: formatHistoryValue(after),
            type:
                before === undefined
                    ? ('added' as const)
                    : after === undefined
                      ? ('removed' as const)
                      : ('replaced' as const),
        },
    };
};
